import Alpine from 'alpinejs';
import component from 'alpinejs-components';
import { cloneDeep, differenceBy, isEqual, uniq } from 'lodash';
import { v4 } from 'uuid';
import axios from 'axios';
import Swiper from 'swiper';
import { Navigation, Pagination, Keyboard } from 'swiper/modules';
import collapse from '@alpinejs/collapse';
import resize from '@alpinejs/resize'
import DOMPurify from 'dompurify';
import api from './util/api';

window.Alpine = Alpine;
window.v4 = v4;
window.api = api;
window.axios = axios;
window.lodash = { cloneDeep, differenceBy, isEqual, uniq };
window.Swiper = Swiper;
window.swiperModules = { Navigation, Pagination, Keyboard };

Alpine.store("search", {
    search: {
        query: "",
        criteria: "",
        sort: "",
        currentPage: 1,
    },
    update(newValues) {
        this.search = { ...this.search, ...newValues };
    },
});

Alpine.store("notify", {
    notification: null,
    queue: [],
    push(message, variant = 'success') {
        if (this.notification) {
            this.queue.push({ message, variant });
        } else {
            this.notification = { message, variant };
        }
    },
});

Alpine.store('thirdPartyViewer', {
    imageUrl: null,
    originalSize: false,
});

Alpine.store("revalidate", {
    value: 0,
    toggle() {
        this.value += 1;
    },
});

Alpine.directive('lazy', (el, { expression }) => {
    el.setAttribute('src', expression);
});
Alpine.directive('intersect', (el, { expression }, { evaluateLater, effect }) => {
    const evaluate = evaluateLater(expression)
    const observer = new IntersectionObserver(([entry]) => {
        if (entry.isIntersecting) evaluate()
    })
    observer.observe(el)
})

Alpine.directive('html-clean', (el, { expression }, { effect, evaluateLater }) => {
    let getContent = evaluateLater(expression);

    effect(() => {
        getContent(raw => {
            let cleaned = (raw || '').replace(/&nbsp;/g, ' ');
            cleaned = cleaned.replace(/\u00A0/g, ' ');
            cleaned = cleaned.replace(/\n/g, '<br>');
            cleaned = cleaned.replaceAll('<p></p>', '<p><br/></p>');

            el.innerHTML = DOMPurify.sanitize(cleaned, {
                ADD_ATTR: ['target', 'rel'],
            });
        });
    });
});

Alpine.directive('template-outlet', ( element, metadata, framework ) => {
    let templateRef = framework.evaluate( metadata.expression );

    let clone = templateRef.content
        .cloneNode( true )
        .firstElementChild;

    Alpine.addScopeToNode(
        clone,
        Alpine.closestDataStack( element )[ 0 ],
        element.parentElement
    );

    let domHook = document.createComment( ` Template outlet hook (${ metadata.expression }) with bindings (${ element.getAttribute( "x-data" ) }). ` );
    domHook._template_outlet_ref = templateRef;
    domHook._template_outlet_clone = clone;

    Alpine.mutateDom(
        function pauseMutationObserver() {

            element.after( domHook );
            domHook.after( clone );
            Alpine.initTree( clone );

            element.remove();
            Alpine.destroyTree( element );

        }
    );
});

Alpine.plugin(component);
Alpine.plugin(collapse);
Alpine.plugin(resize);
Alpine.start();
